import { all, call, put, fork, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux'
import { setAuthToken, setUser, noop } from './actions';
import { SIGN_OUT } from './constants';
import { signOut } from './actions';
import { getItem, removeItem } from 'utils/localStorage';
import { getSession, deleteSession } from 'utils/api';
import { authedApiSaga } from 'sagas';
import { clearState } from 'reducers';

export function* getSessionFlow() {
  yield* authedApiSaga(getSession, [], setUser, signOut);
}

export function* deleteSessionFlow() {
  yield all([
    call(authedApiSaga, deleteSession, [], noop, noop),
    call(removeItem, 'authToken'),
    put(clearState()),
    put(push('/')),
  ]);
}

export default function* appSaga() {
  const token = yield call(getItem, 'authToken');

  if (token) {
    yield put(setAuthToken(token));
    yield fork(getSessionFlow);
  }

  yield takeLatest(SIGN_OUT, deleteSessionFlow);
}



// WEBPACK FOOTER //
// ./src/containers/App/sagas.js